import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DisputeFilter, DisputeKpiStats } from '../dispute.utils';

@Component({
    selector: 'app-dispute-kpi-bar',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="kpi-grid">
            <button
                type="button"
                class="kpi-card kpi-total"
                [class.kpi-active]="activeFilter === 'ALL'"
                (click)="selectFilter('ALL')"
            >
                <span class="kpi-label">Total Claims</span>
                <span class="kpi-value">{{ stats.total }}</span>
            </button>
            <button
                type="button"
                class="kpi-card kpi-submitted"
                [class.kpi-active]="activeFilter === 'SUBMITTED'"
                (click)="selectFilter('SUBMITTED')"
            >
                <span class="kpi-label">Submitted</span>
                <span class="kpi-value">{{ stats.submitted }}</span>
            </button>
            <button
                type="button"
                class="kpi-card kpi-review"
                [class.kpi-active]="activeFilter === 'UNDER_REVIEW'"
                (click)="selectFilter('UNDER_REVIEW')"
            >
                <span class="kpi-label">Under Review</span>
                <span class="kpi-value">{{ stats.underReview }}</span>
            </button>
            <button
                type="button"
                class="kpi-card kpi-approved"
                [class.kpi-active]="activeFilter === 'APPROVED'"
                (click)="selectFilter('APPROVED')"
            >
                <span class="kpi-label">Approved</span>
                <span class="kpi-value">{{ stats.approved }}</span>
            </button>
            <button
                type="button"
                class="kpi-card kpi-rejected"
                [class.kpi-active]="activeFilter === 'REJECTED'"
                (click)="selectFilter('REJECTED')"
            >
                <span class="kpi-label">Rejected</span>
                <span class="kpi-value">{{ stats.rejected }}</span>
            </button>
        </div>
    `,
    styles: [
        `
            .kpi-grid {
                display: grid;
                grid-template-columns: repeat(5, minmax(0, 1fr));
                gap: 0.75rem;
            }
            @media (max-width: 1100px) {
                .kpi-grid {
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                }
            }
            @media (max-width: 640px) {
                .kpi-grid {
                    grid-template-columns: repeat(2, minmax(0, 1fr));
                }
            }
            .kpi-card {
                background: var(--dispute-card, var(--surface-card));
                border: 1px solid var(--dispute-border, var(--surface-border));
                border-radius: 10px;
                padding: 0.85rem 1rem;
                display: flex;
                flex-direction: column;
                gap: 0.35rem;
                border-left-width: 4px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
                cursor: pointer;
                text-align: left;
                width: 100%;
                font: inherit;
                color: inherit;
                transition:
                    box-shadow 0.15s ease,
                    border-color 0.15s ease,
                    transform 0.1s ease;
            }
            .kpi-card:hover {
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                transform: translateY(-1px);
            }
            .kpi-card:focus-visible {
                outline: 2px solid var(--dispute-primary, var(--primary-color));
                outline-offset: 2px;
            }
            .kpi-card.kpi-active {
                border-color: var(--dispute-primary, var(--primary-color));
                box-shadow: 0 0 0 1px var(--dispute-primary, var(--primary-color));
            }
            .kpi-label {
                font-size: 0.72rem;
                color: var(--dispute-muted, var(--text-color-secondary));
                text-transform: uppercase;
                letter-spacing: 0.04em;
            }
            .kpi-value {
                font-size: 1.65rem;
                font-weight: 700;
                line-height: 1;
            }
            .kpi-total {
                border-left-color: var(--p-surface-400);
            }
            .kpi-total .kpi-value {
                color: var(--dispute-kpi-total, var(--text-color));
            }
            .kpi-submitted {
                border-left-color: var(--p-blue-500);
            }
            .kpi-submitted .kpi-value {
                color: var(--dispute-kpi-submitted, var(--p-blue-600));
            }
            .kpi-review {
                border-left-color: var(--p-orange-500);
            }
            .kpi-review .kpi-value {
                color: var(--dispute-kpi-review, var(--p-orange-600));
            }
            .kpi-approved {
                border-left-color: var(--p-green-500);
            }
            .kpi-approved .kpi-value {
                color: var(--dispute-kpi-approved, var(--p-green-600));
            }
            .kpi-rejected {
                border-left-color: var(--p-red-500);
            }
            .kpi-rejected .kpi-value {
                color: var(--dispute-kpi-rejected, var(--p-red-600));
            }
        `
    ]
})
export class DisputeKpiBarComponent {
    @Input({ required: true }) stats!: DisputeKpiStats;
    @Input() activeFilter: DisputeFilter = 'ALL';

    @Output() filterSelect = new EventEmitter<DisputeFilter>();

    selectFilter(filter: DisputeFilter): void {
        this.filterSelect.emit(filter);
    }
}
